import React from "react";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import { BsFillXCircleFill } from "react-icons/bs";
import { colors } from "../../../../../utils/colors";

const MARKS = {
  verified: {
    Icon: FaCheckCircle,
    color: colors.success,
    label: "Address found",
  },
  street_only: {
    Icon: FaExclamationCircle,
    color: colors.warning,
    label: "House number not found",
  },
  not_found: {
    Icon: BsFillXCircleFill,
    color: colors.danger,
    label: "Address not found",
  },
};

function AddressGeoMark({ address }) {
  const mark = MARKS[address?.geo_status];
  if (!mark) return null;

  const { Icon, color, label } = mark;

  return (
    <li
      className="d-flex align-items-center text-xs"
      style={{ color }}
      title={address.geo_formatted || address.geo_query || label}
    >
      <Icon className="mr-1" style={{ fontSize: 13, flexShrink: 0 }} />
      {label}
    </li>
  );
}

export default AddressGeoMark;
